import { render, staticRenderFns } from "./OrgTag.vue?vue&type=template&id=48a2e20d&scoped=true&"
import script from "./OrgTag.vue?vue&type=script&lang=js&"
export * from "./OrgTag.vue?vue&type=script&lang=js&"
import style0 from "./OrgTag.vue?vue&type=style&index=0&id=48a2e20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2e20d",
  null
  
)

export default component.exports